import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

import {
  CONTAINER_NAMES,
  DURATION_NAMES,
  EASE_NAMES,
  HEIGHT_NAMES,
  ICON_CLASSES,
  MIN_HEIGHT_NAMES,
  MIN_WIDTH_NAMES,
  RADIUS_NAMES,
  SHADOW_NAMES,
  SPACING_NAMES,
  TYPE_ROLES,
  WIDTH_NAMES,
  Z_BANDS,
} from "./theme/v3Names"

/**
 * tailwind-merge extended with the design-system names (docs/THEME.md section 3.1). Without this, an unknown
 * `text-<role>` is read as a colour and dropped next to `text-ink`, and `h-control` never merges with `h-9`.
 */
const twMerge = extendTailwindMerge<"icon-size">({
  extend: {
    theme: {
      text: [...TYPE_ROLES],
      spacing: [...SPACING_NAMES],
      radius: [...RADIUS_NAMES],
      shadow: [...SHADOW_NAMES],
      ease: [...EASE_NAMES],
      container: [...CONTAINER_NAMES],
    },
    classGroups: {
      h: [{ h: [...HEIGHT_NAMES] }],
      "min-h": [{ "min-h": [...MIN_HEIGHT_NAMES] }],
      "min-w": [{ "min-w": [...MIN_WIDTH_NAMES] }],
      w: [{ w: [...WIDTH_NAMES] }],
      z: [{ z: [...Z_BANDS] }],
      duration: [{ duration: [...DURATION_NAMES] }],
      "icon-size": [...ICON_CLASSES],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
